const Fantom = () => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
    <circle cx='12' cy='12' r='12' fill='#1969FF' />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12.807 3.813a1.714 1.714 0 0 0-1.614 0L7.263 5.91c-.26.195-.383.407-.397.605h-.009v10.949c0 .253.14.486.363.605l3.973 2.119c.505.269 1.11.269 1.614 0l3.973-2.12a.686.686 0 0 0 .363-.604V6.514h-.008c.011-.237-.11-.474-.398-.605l-3.93-2.096Zm3.65 3.456-3.65 1.946a1.685 1.685 0 0 1-.08.04l3.73 1.99V7.27Zm0 5.485-3.65 1.947a1.714 1.714 0 0 1-1.614 0l-3.65-1.947v4.709l3.973 2.119c.303.161.666.161.968 0l3.973-2.12v-4.708Zm-8.914-1.508 3.731-1.99a1.73 1.73 0 0 1-.08-.04L7.542 7.268v3.977Zm3.973-6.828a1.03 1.03 0 0 1 .968 0l3.93 2.096-3.93 2.096a1.029 1.029 0 0 1-.968 0l-3.93-2.096 3.93-2.096Zm.827 9.74v-4.33L16.414 12l-3.93 2.096a1.038 1.038 0 0 1-.141.062Zm-.686-4.33v4.33a1.027 1.027 0 0 1-.14-.062L7.585 12l4.071-2.171Z'
      clipRule='evenodd'
    />
    <path
      fill='#fff'
      d='m16.982 4.338.566.353c.601.376.966 1.036.966 1.745v.421h-.685v-.421c0-.473-.244-.912-.645-1.163l-.566-.354.364-.581ZM6.453 19.309l.565.353.364-.581-.566-.354a1.371 1.371 0 0 1-.644-1.163v-.421h-.686v.421c0 .71.365 1.369.967 1.745Z'
    />
  </svg>
)

export { Fantom }
